import transverterFn from "i18nData";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import r, { api } from "../../modules/Request";
import "./index.scss";
export default function EmissionDetail() {
  const { id } = r.getQueryString();
  const visitH5Data = useSelector((state) => state.language);
  // const dispatch = useDispatch();
  const [dataVal, setDataVal] = useState([]);
  const [strAll, setStrAll] = useState({}); //写死的翻译数据
  const [resAll, setResAll] = useState([]); //接口返回的总数据

  const getFillReviewFn = async () => {
    try {
      let res = await r.get(api.CARBON_FOOTQRCODE_REDUCTION + id);
      if (res.status.code === "00000") {
        let resData = res.data;
        setDataVal(resData);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if(dataVal){
      if (visitH5Data) {
        setResAll(dataVal?.["zhProductDetail"]);
      } else {
        setResAll(dataVal?.["enProductDetail"]);
      }
      console.log(resAll);
      setStrAll(transverterFn(visitH5Data));
    }
  }, [visitH5Data, dataVal]);
  useEffect(() => {
    getFillReviewFn();
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <div className="emission_detail_box">
        {/* <p className='title'><span style={{fontSize:'.32rem'}}>{strAll?.functionalUnit}</span><span style={{fontSize:'.32rem'}}>{resAll?.featureUnit}</span>/<span style={{fontSize:'.32rem'}}>{resAll?.carbonUnit}</span></p> */}
        <p className="newTitle">
          {strAll?.functionalUnit}
          {resAll?.carbonReductionDetailVO?.featureUnit}/{resAll?.carbonUnit}
        </p>
        <div className="emission_detail_title_box">
          <ul className="emission_detail_title">
            <li>
              <p></p>
              <p className="cp_title">
                <div
                  className="emission_margin child_blue"
                  style={{ paddingBottom: 0 }}
                >
                  {strAll?.BasicProduct}
                </div>
              </p>
              <p className="cp_msg">
                <div
                  className="emission_margin child_dark_blue"
                  style={{ paddingBottom: 0 }}
                >
                  {strAll?.ImprovedProduct}
                </div>
              </p>
              <p className="cp_val">
                <div
                  className="emission_margin child_green"
                  style={{ paddingBottom: 0 }}
                >
                  {strAll?.Reduction}
                </div>
              </p>
            </li>
            <li>
              <p></p>
              <p className="cp_title">
                <div className="cp_margin">
                  {resAll?.carbonReductionDetailVO?.productNameBase}
                </div>
              </p>
              <p className="cp_msg">
                <div className="cp_margin">
                  {resAll?.carbonReductionDetailVO?.productNameImprove}
                </div>
              </p>
              <p className="cp_val"></p>
            </li>
            <li className="pt-75r">
              <p></p>
              <p className="cp_title">
                <div
                  className="emission_margin child_blue"
                  style={{ fontWeight: "400", paddingBottom: ".21rem" }}
                >
                  {resAll?.carbonReductionDetailVO?.carbonBase}
                </div>
              </p>
              <p className="cp_msg">
                <div
                  className="emission_margin child_dark_blue"
                  style={{ fontWeight: "400", paddingBottom: ".21rem" }}
                >
                  {resAll?.carbonReductionDetailVO?.carbonImprove}
                </div>
              </p>
              <p className="cp_val">
                <div
                  className="emission_margin child_green"
                  style={{ fontWeight: "400", paddingBottom: ".21rem" }}
                >
                  {resAll?.carbonReductionDetailVO?.reductionCarbon}
                </div>
              </p>
            </li>
          </ul>
        </div>
        <div>
          {resAll?.stepReductionVODetailList?.map((item) => {
            if (item.nodeLevel === "1") {
              return (
                <div key={item.stepKey} className="head_box">
                  <div className="emission_bor">
                    <div className="emission_margin">{item.name}</div>
                  </div>
                  <div className="emission_bor">
                    <div className="emission_margin">{item.carbonKgBase}</div>
                  </div>
                  <div className="emission_bor">
                    <div className="emission_margin">
                      {item.carbonKgImprove}
                    </div>
                  </div>
                  <div className="emission_bor">
                    <div className="emission_margin child_green">
                      {item.carbonReductionKgImprove}
                    </div>
                  </div>
                </div>
              );
            } else {
              return (
                <div key={item.stepKey} className="td_box">
                  <div className="emission_bor emission_material">
                    <div className="emission_margin">{item.name}</div>
                  </div>
                  <div className="emission_bor">
                    <div className="emission_margin">{item.carbonKgBase}</div>
                  </div>
                  <div className="emission_bor">
                    <div className="emission_margin">
                      {item.carbonKgImprove}
                    </div>
                  </div>
                  <div className="emission_bor">
                    <div className="emission_margin child_green">
                      {item.carbonReductionKgImprove}
                    </div>
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
    </>
  );
}
